/* CatSketch live flat-map repair keys. Loaded after legacy hover scripts. */
(function () {
  var repair = {
    "58643928744251": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__flat.png?v=1779466361",
    "58643928940859": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__flat.png?v=1779466372",
    "58643929301307": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__flat.png?v=1779466383",
    "58643929530683": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__flat.png?v=1779466394",
    "58650664501563": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__calico_autumn_hollow_sentinel__flat__20260523f.png?v=1779561155",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__room": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__flat.png?v=1779466361",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__room_df5edd9d-1110-43b7-bef9": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__flat.png?v=1779466361",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__room_df5edd9d-1110-43b7-bef9-bf39b01c3314": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__russian_blue_mist_pines__flat.png?v=1779466361",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__room": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__flat.png?v=1779466372",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__room_c9263826-fec3-4188-9764": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__flat.png?v=1779466372",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__room_c9263826-fec3-4188-9764-c08959d24251": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__tuxedo_birch_threshold__flat.png?v=1779466372",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__room": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__flat.png?v=1779466383",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__room_7e0ff3af-f7a9-45fb-b0c2": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__flat.png?v=1779466383",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__room_7e0ff3af-f7a9-45fb-b0c2-6a126d5115ec": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__bengal_fern_ravine__flat.png?v=1779466383",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__room": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__flat.png?v=1779466394",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__room_25cf2aa4-f555-4696-ad54": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__flat.png?v=1779466394",
    "woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__room_25cf2aa4-f555-4696-ad54-508f1f93962d": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__approved-20260521__20260522_add5__persian_lichen_grove__flat.png?v=1779466394",
    "woodland-sentinel-canvas__calico_autumn_hollow_sentinel__room__20260523f": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__calico_autumn_hollow_sentinel__flat__20260523f.png?v=1779561155",
    "woodland-sentinel-canvas__calico_autumn_hollow_sentinel__room__20260523f_2fb51b1d-d0d3-4bbf-924f": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__calico_autumn_hollow_sentinel__flat__20260523f.png?v=1779561155",
    "woodland-sentinel-canvas__calico_autumn_hollow_sentinel__room__20260523f_2fb51b1d-d0d3-4bbf-924f-5c14252df21e": "https://cdn.shopify.com/s/files/1/0949/8466/7451/files/woodland-sentinel-canvas__calico_autumn_hollow_sentinel__flat__20260523f.png?v=1779561155"
  };

  window.CLAWDBOT_FLAT_MAP = Object.assign(window.CLAWDBOT_FLAT_MAP || {}, repair);
  window.CLAWDBOT_FLAT_MAP_FALLBACK = Object.assign(window.CLAWDBOT_FLAT_MAP_FALLBACK || {}, repair);

  function installCollectionHoverWhiteFix() {
    var staleStyle = document.getElementById("clawdbot-collection-hover-white-fix-20260528");
    if (staleStyle) {
      staleStyle.textContent = "";
    }
    if (document.getElementById("clawdbot-public-card-hover-guard-20260528")) return;
    var style = document.createElement("style");
    style.id = "clawdbot-public-card-hover-guard-20260528";
    style.textContent = [
      "#product-grid .card-wrapper .media.media--hover-effect,",
      "#product-grid .card-wrapper .card__media .media,",
      ".featured-products .product-card .media.media--hover-effect,",
      ".featured-products .product-card .card__media .media{width:100%!important;height:100%!important;min-height:100%!important;overflow:hidden!important;}",
      "#product-grid .card-wrapper .media.media--hover-effect>img.motion-reduce,",
      "#product-grid .card-wrapper .card__media img.motion-reduce,",
      ".featured-products .product-card .media.media--hover-effect>img.motion-reduce,",
      ".featured-products .product-card .card__media img.motion-reduce{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;opacity:1!important;visibility:visible!important;}",
      "#product-grid .card-wrapper .clawdbot-flat-cycle-overlay,",
      "#product-grid .card-wrapper .clawdbot-zoom-overlay,",
      ".featured-products .product-card .clawdbot-flat-cycle-overlay,",
      ".featured-products .product-card .clawdbot-zoom-overlay{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}"
    ].join("");
    document.head.appendChild(style);
  }

  installCollectionHoverWhiteFix();

  function installProductCardCycleUnblocker() {
    if (window.__clawdbotProductCardCycleUnblocker20260529) return;
    window.__clawdbotProductCardCycleUnblocker20260529 = true;

    var unblockStyle = document.createElement("style");
    unblockStyle.id = "clawdbot-product-card-cycle-unblock-20260529";
    unblockStyle.textContent = [
      "#product-grid .card-wrapper .clawdbot-flat-cycle-overlay,",
      ".featured-products .product-card .clawdbot-flat-cycle-overlay{display:block!important;pointer-events:none!important;}"
    ].join("");
    document.head.appendChild(unblockStyle);

    function cardFromPointer(event) {
      var pointed = null;
      if (event && typeof event.clientX === "number" && typeof event.clientY === "number") {
        pointed = document.elementFromPoint(event.clientX, event.clientY);
      }
      var node = pointed || (event && event.target);
      return (
        node &&
        node.closest &&
        node.closest("#product-grid .card-wrapper, .featured-products .product-card")
      );
    }

    function keepBaseImageVisible(card) {
      card.querySelectorAll(".media.media--hover-effect>img.motion-reduce, .card__media img.motion-reduce, .product-img-wrap img").forEach(function (img) {
        img.style.setProperty("display", "block", "important");
        img.style.setProperty("width", "100%", "important");
        img.style.setProperty("height", "100%", "important");
        img.style.setProperty("object-fit", "cover", "important");
        img.style.setProperty("opacity", "1", "important");
        img.style.setProperty("visibility", "visible", "important");
      });
    }

    function startCycleBeforeStaleGuard(event) {
      var card = cardFromPointer(event);
      if (!card) return;
      var img = card.querySelector("img");
      if (!img || typeof window.clawdbotStartFlatScanCycle !== "function") return;
      keepBaseImageVisible(card);
      var flatInfo = typeof window.clawdbotGetLegacyFlatInfo === "function" ? window.clawdbotGetLegacyFlatInfo(img) : null;
      window.clawdbotStartFlatScanCycle(card, img, flatInfo && flatInfo.url);
      event.stopImmediatePropagation();
    }

    ["pointerover", "pointermove", "mouseover", "mousemove"].forEach(function (eventName) {
      window.addEventListener(eventName, startCycleBeforeStaleGuard, true);
    });
  }

  installProductCardCycleUnblocker();

  function restoreGuardedCard(card) {
    if (!card) return;
    card.querySelectorAll(".clawdbot-flat-cycle-overlay, .clawdbot-zoom-overlay").forEach(function (overlay) {
      overlay.remove();
    });
    card.querySelectorAll(".media.media--hover-effect, .card__media .media").forEach(function (media) {
      var parent = media.closest(".card__inner, .card__media");
      var box = parent && parent.getBoundingClientRect();
      if (box && box.height > 80) {
        media.style.setProperty("height", box.height + "px", "important");
        media.style.setProperty("min-height", box.height + "px", "important");
      }
    });
    card.querySelectorAll(".media.media--hover-effect>img.motion-reduce, .card__media img.motion-reduce").forEach(function (img) {
      img.style.setProperty("display", "block", "important");
      img.style.setProperty("width", "100%", "important");
      img.style.setProperty("height", "100%", "important");
      img.style.setProperty("object-fit", "cover", "important");
      img.style.setProperty("opacity", "1", "important");
      img.style.setProperty("visibility", "visible", "important");
    });
  }

  function guardedCardFromEvent(event) {
    return (
      event.target &&
      event.target.closest &&
      event.target.closest("#product-grid .card-wrapper, .featured-products .product-card")
    );
  }

  ["mouseover", "pointerover", "mousemove"].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        var card = guardedCardFromEvent(event);
        if (!card) return;
        restoreGuardedCard(card);
        event.stopImmediatePropagation();
      },
      true
    );
  });

  function resetCollectionFlatCycle(card) {
    if (!card || !card.classList || !card.classList.contains("card-wrapper")) return;
    card.__clawdbotFlatCycleActive = false;
    card.__clawdbotFlatCycleToken = (card.__clawdbotFlatCycleToken || 0) + 1;
    if (card.__clawdbotFlatCycleTimer) window.clearInterval(card.__clawdbotFlatCycleTimer);
    if (card.__clawdbotFlatCycleFadeTimer) window.clearTimeout(card.__clawdbotFlatCycleFadeTimer);
    card.__clawdbotFlatCycleTimer = null;
    card.__clawdbotFlatCycleFadeTimer = null;
    card.__clawdbotHoverActive = false;
    card.__clawdbotHoverToken = (card.__clawdbotHoverToken || 0) + 1;
    if (card.__clawdbotHoverTimers) card.__clawdbotHoverTimers.forEach(window.clearTimeout);
    card.__clawdbotHoverTimers = [];
    card.querySelectorAll(".clawdbot-flat-cycle-overlay, .clawdbot-zoom-overlay").forEach(function (overlay) {
      overlay.style.setProperty("opacity", "0", "important");
      overlay.style.setProperty("visibility", "hidden", "important");
      overlay.style.setProperty("pointer-events", "none", "important");
    });
  }

  document.addEventListener(
    "mouseleave",
    function (event) {
      var card = event.target && event.target.closest && event.target.closest(".card-wrapper");
      if (card) resetCollectionFlatCycle(card);
    },
    true
  );

  document.addEventListener(
    "mouseout",
    function (event) {
      var card = event.target && event.target.closest && event.target.closest(".card-wrapper");
      if (card && !card.contains(event.relatedTarget)) resetCollectionFlatCycle(card);
    },
    true
  );

  window.addEventListener("blur", function () {
    document.querySelectorAll(".card-wrapper").forEach(resetCollectionFlatCycle);
  });
})();
